<div class="reporting-main-canvas flex-column">
  <div class="top-area-report px-3 py-2">
    <div class="header-card">
    <!-- <span>Berichtswesen <a *canAccess="[1,2,5,7,9]" routerLink="../../report/detailed" routerLinkActive="active"
          mat-button>[alt]</a> </span>
    -->
      <!--     <h2>Berichtswesen </h2> -->

      <div class="header-controls">
        <!-- Toggle Buttons (Projekte / RouteStations) -->
        <section class="toggle-section">
          <mat-button-toggle-group name="menuType" [(ngModel)]="selectedMenu" (ngModelChange)="resetSelection()">
            <mat-button-toggle value="Projekte">Projekte</mat-button-toggle>
            <mat-button-toggle value="RouteStations">RouteStations</mat-button-toggle>
          </mat-button-toggle-group>
        </section>
      </div>
      <!-- Report Buttons (Dynamic) -->
      <div class="reports-menu-container">
        <ng-container *ngFor="let config of getReports(); let i = index">
          <div class="report-menu-item" (mouseenter)="mouseEnter(menuTrigger, config.label)">
            <button mat-stroked-button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"
              [disabled]="isReportDisabled(config)" class="report-button"
              [attr.aria-disabled]="!isReportAvailable(config)">
              <mat-spinner *ngIf="isLoadingReport(config.id)" diameter="18" strokeWidth="2"></mat-spinner>
              <span *ngIf="!isLoadingReport(config.id)">{{ config.label }}</span>
            </button>

            <!-- Main Report Menu -->
            <mat-menu #menu="matMenu" [hasBackdrop]="false" [overlapTrigger]="false">
              <button mat-menu-item (click)="getReport(config.id)" [disabled]="isLoadingReport(config.id)">
                <img src="assets/icons/description_material.svg" height="24"/>
                <span>{{ config.label }} Report</span>
              </button>
              <button mat-menu-item [matMenuTriggerFor]="downloadMenu" [disabled]="isDownloadingReport(config.id)">
                <img src="assets/icons/download_material.svg" height="24"/>
                <span>Download</span>
              </button>
            </mat-menu>

            <!-- Download Submenu -->
            <mat-menu #downloadMenu="matMenu" [hasBackdrop]="false" [overlapTrigger]="false">
              <button mat-menu-item (click)="downloadReport(config.id, 'pdf')"
                [disabled]="isDownloadingReport(config.id)">
                <img src="assets/icons/picture_as_pdf_material.svg" height="24"/>
                <span>PDF</span>
              </button>
              <button mat-menu-item (click)="downloadReport(config.id, 'csv')"
                [disabled]="isDownloadingReport(config.id)">
                <img src="assets/icons/table_chart_material.svg" height="24"/>
                <span>CSV</span>
              </button>
            </mat-menu>
          </div>
        </ng-container>

      </div>
    </div>
  </div>

    <!-- Main Content Area -->
  <div class="d-flex overflow-auto" >
    <!-- Left Sidebar: Filters -->
    <div class="menu-container">
        <div class="filter-bar">
          <div class="filter-area"> 
            <!-- Search Input -->
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>Suche</mat-label>
              <input matInput type="text" [(ngModel)]="searchFilter" placeholder="Projekt, Gruppe oder Station">
              <button *ngIf="searchFilter" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
                <img src="assets/icons/close_material.svg" height="24"/>
              </button>
            </mat-form-field>

            <!-- Date Range Picker -->
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>Zeitraum auswählen</mat-label>
              <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [max]="maxDate">
                <input matStartDate readonly formControlName="start" placeholder="Startdatum" (dateChange)="setMaxDate()">
                <input matEndDate readonly formControlName="end" placeholder="Enddatum"> 
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>

              @if (range.controls['start'].hasError('matStartDateInvalid')) {
              <mat-error>Ungültiges Startdatum</mat-error>
              }
              @if (range.controls['end'].hasError('matEndDateInvalid')) {
              <mat-error>Ungültiges Enddatum</mat-error>
              }
            </mat-form-field>

            <!-- Project Status Filter -->
            @if (selectedMenu === 'Projekte') {
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>Projekt Status</mat-label>
              <mat-select [(value)]="selectedStatus">
                <mat-option value="alle">Alle Projekte</mat-option>
                <mat-option value="aktiv">Aktive Projekte</mat-option>
                <mat-option value="inaktiv">Inaktive Projekte</mat-option>
              </mat-select>
            </mat-form-field>
            }
          </div>
        </div>
        <!-- Reporting Menu (Tree/List) -->
        <div class="overflow-auto flex-1 p-2">
          <avs-reporting-menu [selectedMenu]="selectedMenu" [searchFilter]="searchFilter" [selectedStatus]="selectedStatus"
          (selectionChange)="selectionChange($event)">
          </avs-reporting-menu>
        </div>
    </div>
    <!-- Right Content: Reports -->
    <div class="data-container flex-1 mh-100 h-100 w-100 overflow-auto" >
      <avs-reporting-container [reportCollection]="reportCollection" [selectedIndex]="reportCollection.length-1">
      </avs-reporting-container>  
    </div>
</div>
  <!-- Special Cases Dialog (Modal/Sidenav) -->
<div *ngIf="currentReportConfig" class="special-cases-overlay">
  <div class="special-cases-dialog">
    <div class="special-cases-header">
      <h3>{{ currentReportConfig.label }} - Special Settings</h3>
      <button mat-icon-button (click)="closeSpecialCases()">
        <img src="assets/icons/close_material.svg" height="24"/>
      </button>
    </div>

    <div class="special-cases-content">
      <!-- deChannels Section -->
      <div *ngIf="currentReportConfig.hasDeChannels" class="special-case-section">
        <h4>DE Channels</h4>
        <mat-form-field>
          <mat-label>Select Channels</mat-label>
          <mat-select multiple [(ngModel)]="selectedDeChannels">
            <mat-option *ngFor="let ch of [0, 1, 2, 3, 4, 5]" [value]="ch">
              Channel {{ ch }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Minutes Section -->
      <div *ngIf="currentReportConfig.hasMinutes" class="special-case-section">
        <h4>Minutes</h4>
        <mat-form-field>
          <mat-label>Minutes</mat-label>
          <input matInput type="number" [(ngModel)]="selectedMinutes" min="1" max="10080">
        </mat-form-field>
        <p class="hint">Default: {{ currentReportConfig.minutesDefault }}min</p>
      </div>

      <!-- ioChannels Section -->
      <div *ngIf="currentReportConfig.hasIoChannels" class="special-case-section">
        <h4>I/O Channels</h4>
        <div class="io-channels-list">
          <div *ngFor="let key of (selectedIoChannels | keyvalue)" class="io-channel-item">
            <span>{{ key.key }}: {{ key.value }}</span>
            <button mat-icon-button (click)="removeIoChannel(key.key)">
              <img src="assets/icons/delete_material.svg" height="24"/>
            </button>
          </div>
        </div>
        <div class="io-channel-add">
          <mat-form-field>
            <mat-label>Key</mat-label>
            <input matInput #ioKey>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Value</mat-label>
            <input matInput #ioValue>
          </mat-form-field>
          <button mat-raised-button
            (click)="addIoChannel(ioKey.value, ioValue.value); ioKey.value=''; ioValue.value=''">
            Add
          </button>
        </div>
      </div>
    </div>

    <div class="special-cases-actions">
      <button mat-raised-button (click)="closeSpecialCases()">Cancel</button>
      <button mat-raised-button color="primary" (click)="applySpecialCases()">
        Apply & Load
      </button>
    </div>
  </div>
</div>

 